import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { ChapterFormPageRoutingModule } from "./chapter-form-routing.module";
import { ChapterFormPage } from "./chapter-form.page";
import { TranslateModule } from "@ngx-translate/core";
import { CKEditorModule } from "@ckeditor/ckeditor5-angular";
import { SafeUrlModule } from "src/app/pipes/safe-url/safe-url.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    ChapterFormPageRoutingModule,
    TranslateModule,
    CKEditorModule,
    SafeUrlModule,
  ],
  declarations: [ChapterFormPage],
})
export class ChapterFormPageModule {}
